import { render, staticRenderFns } from "./fundCount.vue?vue&type=template&id=52187eb4&scoped=true"
import script from "./fundCount.vue?vue&type=script&lang=js"
export * from "./fundCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52187eb4",
  null
  
)

export default component.exports